// expo-camera shim for web. The SDK's barcode scanner imports
// `useCameraPermissions` from expo-camera and destructures its return
// as `[permissions, requestPermission]`. With our default empty.cjs
// stub the require returns a proxy whose function-call form returns
// null, which then crashes `permissions[1]`.
//
// This shim provides just enough surface to keep the barcode-scanner
// component from crashing on web. The actual camera UI still won't
// work — but it falls into the permission-denied branch which shows a
// friendly "open this in the mobile app to scan barcodes" CTA.

import type { FC } from 'react';

interface CameraPermissionsResult {
  granted: boolean;
  canAskAgain: boolean;
  status: 'undetermined' | 'granted' | 'denied';
}

export function useCameraPermissions(): [
  CameraPermissionsResult | null,
  () => Promise<CameraPermissionsResult>,
  () => Promise<CameraPermissionsResult>,
] {
  const denied: CameraPermissionsResult = {
    granted: false,
    canAskAgain: false,
    status: 'denied',
  };
  return [
    denied,
    async () => denied,
    async () => denied,
  ];
}

export const CameraView: FC = () => null;
export const Camera: FC = () => null;
export const CameraType = { back: 'back', front: 'front' } as const;
export const FlashMode = { off: 'off', on: 'on', auto: 'auto', torch: 'torch' } as const;
export const PermissionStatus = {
  UNDETERMINED: 'undetermined',
  GRANTED: 'granted',
  DENIED: 'denied',
} as const;

export default {
  useCameraPermissions,
  CameraView,
  Camera,
  CameraType,
  FlashMode,
  PermissionStatus,
};
